
if (!customElements.get("banner-filters")){
class BannerFilters extends HTMLElement {
  constructor() {
    super();

    this.brandInput = this.querySelector('.brand-filter-holder select');
    this.brandChangeEvent = new Event('change', { bubbles: true });
    this.brandInput.addEventListener('change', this.onBrandChange.bind(this));
    
    this.modelInput = this.querySelectorAll('.model-filter-holder select');
    this.modelChangeEvent = new Event('change', { bubbles: true });

    this.modelInput.forEach(select => {
      select.addEventListener('change', this.onModelChange.bind(this));
    });
    
    this.querySelectorAll('.button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  loadUrl(type) {
    if(type == 'json') {
      this.filtersUrl = '/collections/all/?view=json&sort_by=price-descending&';
    }
    else {
      this.filtersUrl = '/collections/all/?sort_by=price-descending&';
    }

    console.log('loading filters url');
    
    var brandOption = this.brandInput.options[this.brandInput.selectedIndex]; // Get the selected <option>

    if(!brandOption.hasAttribute('disabled')){
      this.filtersUrl += this.brandInput.getAttribute('name') + '=' + this.brandInput.value + '&';
    }

    if(this.querySelector('.model-filter-holder') && this.currentModelWrapperSelect){

      var modelOption = this.currentModelWrapperSelect.options[this.currentModelWrapperSelect.selectedIndex]; // Get the selected <option>
  
      if(!modelOption.hasAttribute('disabled')){
        this.filtersUrl += this.currentModelWrapperSelect.getAttribute('name') + '=' + encodeURIComponent(this.currentModelWrapperSelect.value);
      }
    }
    console.log('final url:', this.filtersUrl);

    return this.filtersUrl;
  }
  
  onModelChange(event){
    this.loadProductsNumber();
  }

onButtonClick(event) {
  window.location.href = this.loadUrl('link');
}

  loadProductsNumber(){
    this.classList.add('loading');
    this.classList.remove('loaded');


fetch(this.loadUrl('json'))
    .then((response) => {
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json(); // Parse the response as JSON
    })
    .then((data) => {
      console.log(data);
        const productCount = data.product_count; // Assign the products_count to the variable
        console.log('Number of products:', productCount); // Use the variable as needed
      this.querySelector('.loaded-label .products-number').innerHTML = productCount;
    this.classList.add('loaded');
    this.classList.remove('loading');
    })
    .catch((error) => {
        console.error('Error fetching JSON data:', error);
    });
    
  }
  
  onBrandChange(event) {
    var currentBrand = this.brandInput.value;

    console.log('currentBrand: ', currentBrand);
    
    if(this.currentModelWrapper){
      this.currentModelWrapper.style.display = 'none';
    }
    
    this.currentModelWrapper = this.querySelector('.model-filter-holder[data-brand="'+this.brandInput.value+'"]');
    this.currentModelWrapperSelect = this.querySelector('.model-filter-holder[data-brand="'+this.brandInput.value+'"] select');
    
    if(this.currentModelWrapper) {
      this.currentModelWrapper.style.display = 'block';
    }

    this.loadProductsNumber();
  }
}
customElements.define('banner-filters', BannerFilters);
}